import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAllTeams = async () => {
  try {
    const resp = await apiClient.get(`/teamManagement`, {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
